import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  Modal,
  Image,
  Row,
  Select,
  Tooltip,
  Table,
  Dropdown,
  Menu,
} from "antd";

import { useContext, useEffect, useState } from "react";
import { BASE_BE_URL, SignedInContext } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import {
  ALMSG_INTERNAL_ERR,
  ALMSG_TIMEOUT,
  BASE_DOC_SUBURL,
  DOC_PATH,
} from "../env";
import { emptyStudio, Studio } from "./interfaces";
import { editStudio, getStudioLogoImg, uploadNewLogo } from "./utils";
import { ColumnsType } from "antd/lib/table";
import { Doctor, emptyDoctor } from "../doctor/interfaces";
import { getAllDoctors, getDoctorData } from "../doctor/utils";
import AddDoctorModal from "../doctor/AddDoctorModal";
import Plusbutton from "../buttons/plusbutton";
import PlusButtonDoc from "../buttons/plusbuttonDoc";
import { useNavigate } from "react-router-dom";
import EditDoctorInfoY from "../doctor/EditDoctorInfoY";
import EditDoctorInfoX from "../doctor/EditDoctorInfoX";
import EditDoctorInfo from "../doctor/EditDoctorInfo";
import AddDoctorModalY from "../doctor/AddDoctorModalY";

//ALL OLD DOWN

const { Option } = Select;

const layout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 },
};

const EditStudioInfo = ({
  baseStudio,
  setBaseStudio,
}: {
  baseStudio: Studio;
  setBaseStudio?: Function;
}) => {
  const navigate = useNavigate();
  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;
  const [editError, setEditError] = useState("");
  const [editSuccess, setEditSuccess] = useState("");

  const [studio, setStudio] = useState(baseStudio);

  const [form] = Form.useForm();
  const [compiledBase, setCompiledBase] = useState(false);
  const [modalLogoVisible, setModalLogoVisible] = useState(false);

  const [selectedLogo, setSelectedLogo] = useState<File>();
  const [logo64, setLogo64] = useState<string>();

  //For responsive

  const [width, setWidth] = useState(0);
  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    //mount
    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //End Responsive preview

  const [doctors, setDoctors] = useState<Doctor[]>([]);
  useEffect(() => {
    // Chiamata all'API lato server per ottenere i dati dei medici
    getAllDoctors(signedInDoctor).then((fetchedDoctors) => {
      if (fetchedDoctors.length > 0) {
        setDoctors(fetchedDoctors);
      }
    });
  }, [signedInDoctor]);

  console.log("i Dottori:", doctors);

  useEffect(() => {
    //every time that medical studio data changes, check validity of required fields
    const validFullName: boolean =
      studio.fullName != undefined && studio.fullName.length >= 2;
    //const validVat: boolean =
    //  studio.vat != undefined && studio.vat.length == 11;
    const validLogoURL: boolean =
      studio.logo != undefined && studio.logo.length >= 4;
    setCompiledBase(validFullName /*&& validVat */ && validLogoURL);
  }, [studio, signedInDoctor]);

  useEffect(() => {
    if (editError != "") setTimeout(() => setEditError(""), ALMSG_TIMEOUT);
    if (editSuccess != "") setTimeout(() => setEditSuccess(""), ALMSG_TIMEOUT);
  }, [editError, editSuccess]);

  useEffect(() => {
    getStudioLogoImg(signedInDoctor, studio).then((blob) => {
      console.log(blob);
      if (blob) setLogo64(URL.createObjectURL(blob));
    });
  }, [studio]);

  function updateStudioData(): void {
    throw new Error("Function not implemented.");
  }

  interface DoctorRow extends Doctor {
    key: number;
  }

  const columns: ColumnsType<Doctor> = [
    {
      title: "Id",
      dataIndex: "id",

      defaultSortOrder: "descend",
    },
    {
      title: "Nome",
      dataIndex: "name",
    },
    {
      title: "Cognome",
      dataIndex: "surname",
    },
    {
      title: "Username",
      dataIndex: "username",
    },
    {
      title: "E-mail",
      dataIndex: "email",
    },
    {
      title: "Contatto telefonico",
      dataIndex: "telephone",
    },
    {
      title: "Admin",
      dataIndex: "studioMaster",
      render: (studioMaster: boolean) => (
        <span>{studioMaster ? "Si" : "No"}</span>
      ),
    },
  ];

  const columns2: ColumnsType<Doctor> = [
    {
      title: "Nome",
      dataIndex: "name",
    },
    {
      title: "Cognome",
      dataIndex: "surname",
    },

    {
      title: "Admin",
      dataIndex: "studioMaster",
      render: (studioMaster: boolean) => (
        <span>{studioMaster ? "Si" : "No"}</span>
      ),
    },
  ];

  const [doctory, setDoctory] = useState(emptyDoctor);

  const [addDoctorVisible, setAddDoctorVisible] = useState(false);

  const [addDoctorYVisible, setAddDoctorYVisible] = useState(false);

  return (
    <>
      <Form
        {...layout}
        form={form}
        name="control-hooks"
        initialValues={{ ...studio }}
        onFinish={() => updateStudioData()}
        layout="vertical"
      >
        <>
          <Form.Item
            style={{
              marginLeft: "auto",
              marginRight: "5%",
              marginTop: "-5%",
              textAlign: "right",
            }}
          >
            <button
              className="traspiz"
              onClick={() => setAddDoctorVisible(true)}
            >
              <PlusButtonDoc />
            </button>

            <AddDoctorModal
              visible={addDoctorVisible}
              setVisible={setAddDoctorVisible}
            />
          </Form.Item>
          {width > 768 && (
            <Table
              className="patient-table"
              columns={columns}
              dataSource={doctors}
              style={{ marginLeft: "5%", marginRight: "5%" }}
              pagination={{ pageSize: 10 }}
              onRow={(record: Doctor) => {
                return {
                  onClick: (event) => {
                    setAddDoctorYVisible(true);

                    console.log("huffy", record);
                  },
                };
              }}
            />
          )}
          {width <= 768 && (
            //Mobiole
            <Table
              className="patient-table"
              columns={columns2}
              dataSource={doctors}
              style={{ marginLeft: "5%", marginRight: "5%" }}
              pagination={{ pageSize: 8 }}
              onRow={(record: Doctor) => {
                return {
                  onClick: (event) => {
                    setAddDoctorYVisible(true);

                    console.log("huffy", record);
                  },
                };
              }}
            />
          )}
        </>

        <Form.Item>
          {editError && (
            <Alert
              message="Operazione non riuscita"
              description={editError}
              type="error"
              showIcon
            />
          )}
          {!editError && editSuccess && (
            <Alert
              message="Operazione riuscita"
              description={editSuccess}
              type="success"
              showIcon
            />
          )}
        </Form.Item>
      </Form>
    </>
  );
};

export default EditStudioInfo;
